export const FORM_BASE = 'programForm/FORM_BASE';
export const FORM_SUBMITTED = 'programForm/FORM_SUBMITTED';
export const FORM_SUBMITTING = 'programForm/FORM_SUBMITTING';
export const FORM_SET = 'programForm/FORM_SET';
export const UPDATE_SETS_VIDEO = 'programForm/UPDATE_SETS_VIDEO';
